import * as React from 'react';
import { IDashContactDue } from '@nkr/models/index';
import { TableWrapper } from './styles';

interface IProps {
    list: IDashContactDue[],
    centerId: number
}

const DashContactsDue: React.FunctionComponent<IProps> = (props) => {
    return (
        <TableWrapper className='table table-condensed'>
            <thead>
                <tr>
                    <th colSpan={3}></th>
                    <th colSpan={2}>Intended Recipient</th>
                    <th></th>
                </tr>
                <tr>
                    <th>Source</th>
                    <th>Name</th>
                    <th>Contact By</th>
                    <th>Name</th>
                    <th>Date of Birth</th>
                    <th>Donor Coordinator</th>
                </tr>
            </thead>
            <tbody>
                {props.list.map((item, index) =>
                    <tr key={index}>
                        <td>{item.source}</td>
                        <td><a href={`center/${props.centerId}/donors/donor-intake/details/${item.id}`} target='_blank'>{item.name}</a></td>
                        <td>{item.contactBy}</td>
                        <td>{item.intendedRecipientName}</td>
                        <td>{item.intendedRecipientDoB}</td>
                        <td>{item.donorCoordinator}</td>
                    </tr>
                )}
            </tbody>
        </TableWrapper>
    );
}

export default DashContactsDue;